import clsx from 'clsx';
import React from 'react';

import img50 from 'images/pro/50.png';
import imgAmazon from 'images/pro/Amazon.png';
import imgCEDB from 'images/pro/CE_DB.png';
import imgGoogle from 'images/pro/Google.png';
import imgMeta from 'images/pro/Meta.png';
import imgProWeekly from 'images/pro/ProWeekly_Landing.svg';
import imgVC from 'images/pro/VC.png';

const ProMarketingCTAs = ({ shouldOverlapPaywall }: { shouldOverlapPaywall?: boolean }) => (
  <div
    id="pro-marketing-ctas"
    className={clsx('bg-grayscale-beige px-16 xs:px-48', {
      '-mt-40 pb-32 pt-48 md:-mt-[120px] md:pb-72 md:pt-[152px]': shouldOverlapPaywall,
      'py-32 md:py-72': !shouldOverlapPaywall,
    })}
  >
    <div className="mx-auto md:max-w-[1024px]">
      <p className="m-0 font-suisse-neue text-headline-sm text-primary-black md:text-headline-lg">
        You{'’'}ll have access to:
      </p>
      <div className="border-b-3 mt-32 justify-between gap-x-[44px] border-0 border-solid border-white pb-48 sm:flex md:mt-48 md:pb-64">
        <div className="sm:max-w-[458px]">
          <h3 className="m-0 font-suisse-neue text-headline-xs text-primary-black">
            Org Chart Library
          </h3>
          <p className="m-0 mt-8 font-suisse-neue text-paragraph text-black">
            Our one-of-a-kind org charts track the thousands of individuals who lead the most
            consequential companies. Use these charts to study your competitors and target
            candidates for recruitment. We add and update org charts monthly.
          </p>
        </div>
        <div className="mt-16 flex flex-nowrap items-center justify-center gap-x-[44px] xs:flex-wrap sm:m-0 sm:max-w-[50%] md:flex-nowrap">
          <div className="w-[100px] md:w-[150px]">
            <img
              className="block min-h-[50px] w-full object-contain object-center"
              src={imgGoogle}
              alt="Google"
            />
          </div>
          <div className="w-[100px] md:w-[150px]">
            <img
              className="block min-h-[50px] w-full object-contain object-center"
              src={imgAmazon}
              alt="Amazon"
            />
          </div>
          <div className="w-[100px] md:w-[150px]">
            <img
              className="block min-h-[50px] w-full object-contain object-center"
              src={imgMeta}
              alt="Meta"
            />
          </div>
        </div>
      </div>
      <div className="border-b-3 items-center justify-between gap-x-64 border-0 border-solid border-white py-48 sm:flex md:py-64">
        <div className="sm:order-1 sm:max-w-[458px]">
          <h3 className="m-0 font-suisse-neue text-headline-xs text-primary-black">
            Proprietary Databases and Surveys
          </h3>
          <p className="m-0 mt-8 font-suisse-neue text-paragraph text-black">
            We{'’'}ve gathered unique data points on the most salient sectors of tech—and keep our
            resources up to date through hundreds of hours of reporting each month. You
            {'’'}ll have access to the Creator Economy Database, The Information{'’'}s 50 Most
            Promising Startups, VC Diversity Index and more, along with our monthly subscriber
            survey results.
          </p>
        </div>
        <div className="mt-24 flex flex-nowrap items-center justify-center gap-x-20 xs:flex-wrap sm:m-0 sm:max-w-[50%] md:flex-nowrap md:gap-x-32">
          <div className="w-[100px] md:w-[150px]">
            <img className="block w-full object-contain" src={img50} alt="The Information 50" />
          </div>
          <div className="w-[100px] md:w-[150px]">
            <img className="block w-full object-contain" src={imgVC} alt="VC Diversity Index" />
          </div>
          <div className="w-[100px] md:w-[150px]">
            <img
              className="block w-full object-contain"
              src={imgCEDB}
              alt="Creator Economy Database"
            />
          </div>
        </div>
      </div>
      <div className="items-center gap-x-48 pt-48 sm:flex md:pt-64">
        <div className="sm:max-w-[458px]">
          <h3 className="m-0 font-suisse-neue text-headline-xs text-primary-black">
            The Information Pro Weekly Wrap
          </h3>
          <p className="m-0 mt-8 font-suisse-neue text-paragraph text-black">
            We{'’'}ll sort through and analyze the most significant updates to our data each week in
            an exclusive newsletter for Pro subscribers.
          </p>
        </div>
        <div className="mx-auto mt-24 w-[350px] max-w-full sm:m-0 sm:w-auto">
          <img className="block w-full object-contain" src={imgProWeekly} alt="" />
        </div>
      </div>
    </div>
  </div>
);

export default ProMarketingCTAs;
